import React from 'react';
import { calculatePasswordStrength, getPasswordStrengthText, getPasswordStrengthColor } from '../utils/passwordValidator';

interface PasswordStrengthMeterProps {
  password: string;
}

const PasswordStrengthMeter: React.FC<PasswordStrengthMeterProps> = ({ password }) => {
  const strength = calculatePasswordStrength(password);
  const strengthText = getPasswordStrengthText(strength);
  const strengthColor = getPasswordStrengthColor(strength);

  return (
    <div className="password-strength-meter">
      <div className="strength-meter">
        <div 
          className="strength-meter-fill" 
          style={{ 
            width: `${strength}%`, 
            backgroundColor: strengthColor,
            height: '8px',
            borderRadius: '4px',
            transition: 'width 0.3s ease-in-out, background-color 0.3s ease-in-out'
          }}
        />
      </div>
      <div className="strength-text" style={{ marginTop: '5px', fontSize: '0.8rem', color: strengthColor }}>
        {password && `Force du mot de passe: ${strengthText}`}
      </div>
    </div>
  );
};

export default PasswordStrengthMeter;
